import angular from 'angular';
import common from './core.module';
import atcBackground from './directives/atc-background';
import BookingMovements from './directives/atc-booking-movements';
import Calendar from './directives/atc-calendar';
import CalendarEvent from './directives/atc-calendar-event';
import atcPaymentType from './directives/atc-payment-type.directive';
import contenteditable from './directives/contenteditable';
import EmptyLinksDirective from './directives/empty-links';
import imgCroppie from './directives/img-cropie';
import ngChecklistModel from './directives/ng-checklist-model';
import NgEnter from './directives/ng-enter';
import ngPercentage from './directives/ng-percentage';
import ngPrice from './directives/ng-price';
import OffClick from './directives/off-click';
import {PanelTool, PanelDismiss, PanelRefresh} from './directives/panel-tools';
import PerfectScrollbar from './directives/perfect-scrollbar';
import phoneFormatter from './directives/phone-formatter';
import phoneInput from './directives/phone-input';
import {Sidebar, AppSide, SidebarMobileToggler, SearchForm}  from './directives/sidebars';
import {ToggleHelper, CtToggle, ToggleHelperInit, Toggeable} from './directives/toggle';
import {NavbarDirective} from './directives/nav-bar';

const moduleName = 'atc-directives';
angular.module(moduleName, [common])
    .directive('atcBackground', atcBackground)
    .directive('atcCalendar', Calendar)
    .directive('atcCalendarEvent', CalendarEvent)
    .directive('atcBookingMovements', BookingMovements)
    .directive('atcPaymentType', atcPaymentType)
    .directive('contenteditable', contenteditable)
    .directive('a', EmptyLinksDirective)
    .directive('imgCroppie', imgCroppie)
    .directive('ngChecklistModel', ngChecklistModel)
    .directive('ngEnter', NgEnter)
    .directive('ngPercentage', ngPercentage)
    .directive('ngPrice', ngPrice)
    .directive('offClick', OffClick)
    .directive('ctPaneltool', PanelTool)
    .directive('panelDismiss', PanelDismiss)
    .directive('panelRefresh', PanelRefresh)
    .directive('perfectScrollbar', PerfectScrollbar)
    .directive('phoneFormatter', phoneFormatter)
    .directive('sidebar', Sidebar)
    .directive('appAside', AppSide)
    .directive('sidebarMobileToggler', SidebarMobileToggler)
    .directive('searchForm', SearchForm)
    .factory('ToggleHelper', ToggleHelper)
    .run(ToggleHelperInit)
    .directive('ctToggle', CtToggle)
    .directive('toggleable', Toggeable)
    .directive('phoneInput', phoneInput)
    .directive('topNavbar', NavbarDirective)

;

export default moduleName;